import React from 'react';
import {
  EditDisclaimerWrapper,
  AlertIcon,
  Disclaimer,
  DisclaimerText
} from './EditPasswordDisclaimer.styles';

const EditPasswordDisclaimer = () => (
  <EditDisclaimerWrapper className="edit-password">
    <AlertIcon />
    <Disclaimer>
      <DisclaimerText>
        <strong>WARNING: </strong>
        After changing your password, you will be required to sign back in.
      </DisclaimerText>
    </Disclaimer>
  </EditDisclaimerWrapper>
);

export default EditPasswordDisclaimer;
